<template>
  <div class="wg-about-us">
    <div class="themesflat-container">
      <div class="row">
        <div class="col-lg-7 d-flex align-items-center">
          <div class="content">
            <div class="heading-section">
              <div class="sub ">{{ $t("about_coffee_shop") }}</div>
              <div class="main " :lang="langStore.lang === 'gr' ? 'el' : 'en'">{{ about.title }} <br /></div>
              <div class="divider "><div></div></div>
              <div class="description ">
                {{ about.small_description }}
              </div>
            </div>
            <p class="">
              {{ about.description }}
            </p>
          </div>
        </div>
        <div class="col-lg-5">
          <div class="image fadeInRight">
            <img
              style="height: 564px; object-fit: cover"
              class="w-full"
              :src="getImageUrl(about.image)"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { langStore } from "../../langStore";

export default {
  name: "AboutUsComponent",
  props: {
    msg: String,
  },
  data() {
    return {
      langStore,
      about: {},
    };
  },

  watch: {
    "langStore.lang"() {
      this.fetchAbout();
    },
  },

  mounted() {
    this.fetchAbout();
  },

  methods: {
    async fetchAbout() {
      try {
        const response = await axios.get(
          `${process.env.VUE_APP_BASE_URL}/api/about`,
          { params: { lang: this.langStore.lang } }
        );

        this.about = response.data;

        // WAIT FOR IMAGES TO LOAD
        this.waitForImages();
      } catch (error) {
        console.error("There was an error fetching the data:", error);
        this.$emitContentReady(); // still hide preload
      }
    },
    getImageUrl(photo) {
      return `${process.env.VUE_APP_BASE_URL}/uploads/website/` + photo;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.image {
  width: 100%;
  height: 100%; /* or a fixed height if needed */
  overflow: hidden;
}

.image img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* fills container, crops excess, no stretching */
  display: block;
}
</style>
